import { Grid } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./LabelControlService";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultCheckBoxSelect from "../../componentes/checkbox-select/DefaultCheckboxSelect";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import GridButtonRow from "../../componentes/form-grids/GridButtonRow";
import DefaultButton from "../../componentes/button/DefaultButton";

export const LabelShippingProduct = () => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        numberDocument: "",
        products: Array(5).fill().map(() => ({
            idProduct: 0,
            productGroup: 0,
            productCode: "",
            productName: "",
            qttyBox:"",
            barCode:"",
        })),
        opcaoValue: true,
        dtBatch: null,
        rows: [],
        rowsProduct: [],
        userId: userId,
        cdStatus: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { dtBatch, products, opcaoValue } = state
    const { success, error, rows, rowsProduct, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }

    const handleChangeProduct = (index, { target: { name, value } }) => {
        const updatedProducts = [...state.products];
        updatedProducts[index][name] = value;
        dispatch({ type: "update", data: { products: updatedProducts } });
    };

    const canPrint = () => {
        let verify = true;
        if (opcaoValue)  
        {
            if (dtBatch === null)
            {
                verify = false;
            }
        }

        state.products.forEach((product, index) => {
            if (product.productCode && !product.qttyBox) {
                verify = false;
            }
        });

        if (!verify)
        {
            dispatch({ type: 'error' })
        }
        return verify;
    };


    const handlePrint = () => {
        if (!canPrint())
        {
            return;
        }

        let request = {
            ...data,
            products: state.products.map(p => ({
                ...p,
                qttyBox: p.qttyBox ? Number(p.qttyBox) : 0,
                productCode: state.productCode
            })),
            
        };

        if (!opcaoValue) {
            delete request.dtBatch;
        }
        
        ControlService
            .sendPrint(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'success' })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    };

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.productCode && !product.productName) { 
                // Só busca se o código existe e o nome ainda não foi preenchido
                handleCodeProduct(index, product.productCode);
            }
        });
    }, [state.products.map(p => p.productCode).join(",")]);

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.barCode && !product.productName) { 
                // Só busca se o código de barras existe e o nome ainda não foi preenchido
                handleBarCode(index, product.barCode);
            }
        });
    }, [state.products.map(p => p.barCode).join(",")]);

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.productName && product.idProduct === 0) { 
                // Só busca se o código de barras existe e o nome ainda não foi preenchido
                handleProductName(index, product.productName);
            }
        });
    }, [state.products.map(p => p.productName).join(",")]);


    const handleCodeProduct = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            productCode: code, 
            productGroup: product.idProductGroup  // usa o grupo específico
        };

        ControlService
            .getByCodeProduct(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        barCode: response.data.barCode,
                        productName: response.data.productName
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const handleBarCode = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            barCode: code, 
            productGroup: product.productGroup  // usa o grupo específico
        };

        ControlService
            .getByBarCode(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        productName: response.data.productName
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const handleProductName = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            productName: code, 
            productGroup: product.productGroup  // usa o grupo específico
        };

        ControlService
            .getByProductName(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        barCode: response.data.barCode
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const opcao = [{ name: "opcaoValue", text: t("labelsByBatch"), value: opcaoValue }]

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={2}>
                            <DefaultCheckBoxSelect
                                name="generate"
                                list={opcao}
                                onChange={handleChange}
                                spacing={12} // ocupa a linha inteira
                                error={false}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={6} md={2}>
                            {opcaoValue ?
                                <CustomDatePicker
                                    id="dtBatch"
                                    name="dtBatch"
                                    selectedDate={dtBatch}
                                    handleChange={handleChange}
                                    error={error && dtBatch === null}

                                />
                            : null}
                        </Grid>
                        
                    </GridInputRow>

                    {state.products.map((product, index) => (
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={2}>
                                <DefaultAutocomplete
                                    name={"idProductGroup"}
                                    onChange={(e) => handleChangeProduct(index, e)}
                                    placeholder={t("productGroup")}
                                    label={t("productGroup")}
                                    useApi
                                    endpoint='GetProductGroupListAutoComplete'
                                    value={product.idProductGroup}
                                    defaultSize
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="code" labelName="productCode" />
                                    }
                                    name="productCode"
                                    control={control}
                                    defaultValue=""
                                    label={t("productCode")}
                                    onChange={(e) => handleChangeProduct(index, e)}
                                    value={product.productCode}
                                    length={30}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="code" labelName="barCode" />
                                    }
                                    name="barCode"
                                    control={control}
                                    defaultValue=""
                                    onChange={(e) => handleChangeProduct(index, e)}
                                    value={product.barCode}
                                    length={30}
                                    label={t("barCode")}
                                    error={error && product.productCode && product.barCode === ""}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="product" labelName="productName" />
                                    } 
                                    name="productName"
                                    control={control}
                                    defaultValue=""
                                    onChange={(e) => handleChangeProduct(index, e)}
                                    value={product.productName}
                                    label={t("productName")}
                                    length={100}
                                    error={error && product.productCode && product.productName === ""}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} md={2}>
                                
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="qtty" labelName="qttyBox" />
                                    }
                                    name="qttyBox"
                                    control={control}
                                    defaultValue=""
                                    onChange={(e) => handleChangeProduct(index, e)}
                                    label={t("qtdeBox")}
                                    value={product.qttyBox}
                                    length={10}
                                    inputProps={{ type: "number" }}
                                    error={error && product.productCode && product.qttyBox === ""}
                                />
                                
                            </Grid>
                        </GridInputRow>
                    ))}

                    <GridButtonRow>
                        <Grid item xs={4} sm={3} md={2}>
                            <DefaultButton clear className="secondaryButton" onClick={() => dispatch({ type: 'clear' })} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("sendPrint")} className="primaryButton" onClick={handlePrint} />
                        </Grid>
                    </GridButtonRow>

                </GridItemContainer>
            } />
    );
}